import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConstantsService {
  toastLifeTimeMillis = 6000;
  birthDateYearsRange = `1900:${new Date(Date.now()).getFullYear()}`;
}
